<ppl-box-section
  title="Your mobile devices"
  i18n-title="@@Your_mobile_devices">
  <div
    class="description"
    i18n="@@List_of_mobile_devices_where_you_are_currently_signed_in_with_QR_Code:">
    List of mobile devices where you are currently signed in with QR Code:
  </div>

  @if (sessions$ | async; as sessions) {
    @if (sessions.state === AsyncState.FETCHING) {
      <ppl-loading
        [large]="true"
        [inverse]="true"></ppl-loading>
    }
    @if (sessions.state === AsyncState.FETCHED) {
      <div>
        @for (session of sessions.value; track trackById($index, session)) {
          <ppl-mobile-sign-in-session-item
            [session]="session"
            (signOutClick)="onSignOutClick(session.id)"></ppl-mobile-sign-in-session-item>
        }
        @if (sessions.value.length === 0) {
          <div
            class="no-sessions"
            i18n="@@You_have_no_signed_in_mobile_devices.">
            You have no signed in mobile devices.
          </div>
        }
      </div>
    }
    @if (sessions.state === AsyncState.ERROR) {
      <div>Error</div>
    }
  }
</ppl-box-section>
